@if (isLoaded()) {
  <div class="card">
    @if (!hasPackage) {
      <div class="text-md-semibold text-gray-900">Bez paketa</div>
      <div class="mt-4 empty-state flex flex-column align-items-center justify-content-center gap-2">
        <div class="empty-icon flex align-items-center justify-content-center">
          <app-info-circle stroke="#414651" width="20" height="20"></app-info-circle>
        </div>
        <div class="text-md-semibold text-gray-900">Bez paketa</div>
        <div class="text-sm-regular text-gray-600">Klijent još uvek nema kupljene pakete</div>
      </div>
    } @else {
      <div class="flex align-items-start justify-content-between gap-3">
        <div class="flex flex-column gap-1">
          <div class="text-md-semibold text-gray-900">{{ title }}</div>
          <div class="text-sm-regular text-gray-600">
            {{ subtitleLabel }} <span class="text-sm-medium text-gray-900">{{ subtitleValue }}</span>
          </div>
        </div>
        <p-chip [label]="chipLabel" [class]="chipClass"></p-chip>
      </div>

      <div class="mt-4 grid-2">
        <div class="stat-tile flex align-items-center gap-3">
          <div class="stat-icon">
            <app-cube-01 stroke="#414651" width="16" height="16"></app-cube-01>
          </div>
          <div class="flex flex-column">
            <span class="text-sm-medium text-gray-600">Paket</span>
            <span class="display-xs-semibold text-gray-900">{{ pkg()?.packageName || '-' }}</span>
          </div>
        </div>

        <div class="stat-tile flex align-items-center gap-3">
          <div class="stat-icon">
            <app-calendar stroke="#414651" width="16" height="16"></app-calendar>
          </div>
          <div class="flex flex-column">
            @if (isActive) {
              <span class="text-sm-medium text-gray-600">Zakazano</span>
              <span class="display-xs-semibold text-gray-900">{{ pkg()?.activeAppointments ?? 0 }}</span>
            } @else {
              <span class="text-sm-medium text-gray-600">Datum zahteva</span>
              <span class="display-xs-semibold text-gray-900">{{ datumZahtevaFormatted }}</span>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
